const gloNonMonogramCodelist = {
    'DTGAmBulldog': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1882EDg++gsb06e1bdoLDs/mWkhU6AOQcQ=') + '.png?v=1699374667',
        code: 'U2FsdGVkX19RZ+K3H8QqLP3lGk8BLl4AG5qfjiWN6A8=',
    },
    'DTGMamaClaus': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1+11ma61n7wQw0z79c07d8dOw/Iv8cO8Ow=') + '.png?v=1698593518',
        code: 'U2FsdGVkX1+11ma61n7wQw0z79c07d8dOw/Iv8cO8Ow=',
    },
    'DTGSmile': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1/ixyZUTw9K2FeIxzf+0JzE7ZuPMQ4BZBo=') + 'Block.png?v=1646992840',
        code: 'U2FsdGVkX1/ixyZUTw9K2FeIxzf+0JzE7ZuPMQ4BZBo=',
    },
    'DTGNash': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1+VlntGmHQRjt/2iBTfaccZJGBkGmii+Rk=') + 'Black.png?v=1645791301',
        code: 'U2FsdGVkX1+VlntGmHQRjt/2iBTfaccZJGBkGmii+Rk=',
    },
    'DTGNYC': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX190/NsyKmu3ioT6z3RcSIOMB8QIA6WxqMQ=') + '.png?v=1645791312',
        code: 'U2FsdGVkX190/NsyKmu3ioT6z3RcSIOMB8QIA6WxqMQ=',
    },
    'DTGDiego': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX183xLN+Rk+UJHGUWMLZo8LGGytMMLmF+Gw=') + '.png?v=1645791291',
        code: 'U2FsdGVkX183xLN+Rk+UJHGUWMLZo8LGGytMMLmF+Gw=',
    },
    'DTGDunkinHappy': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX18H8AI3cwk6FERQU4XVMU4jOVxZxdWe+2M=') + '.png?v=1707918253',
        code: 'U2FsdGVkX18H8AI3cwk6FERQU4XVMU4jOVxZxdWe+2M=',
    },
    'DTGXmasSodaChick': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX19We0PxHcyUK+M32jHlewzXwQRJG3jCjdY=') + '.png?v=1699374667',
        code: 'U2FsdGVkX180UERKGCYO+5I3ptmeYxxmruWAzdf5LeSigoPn9CHaVFkEaTw8hUfa',

    },
    'DTGBow': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1/UEGYPvu3mLKKklL4M4Pw9WsfhB0MCHaM=') + 'Bevs.png?v=1707813135',
        code: 'U2FsdGVkX1/UEGYPvu3mLKKklL4M4Pw9WsfhB0MCHaM=',
    },



};